import { DefaultTheme, createGlobalStyle } from 'styled-components'

const StyledTheme: DefaultTheme = {
  fontFamily: "'SF Pro Display', sans-serif",

  borderRadius: '5px',

  colors: {
    primary: '#5A58F2',
    secondary: 'white',
  },

  responsive: {
    tablet: {
      valueString: '1024px',
      valueNumber: 1024,
    },
    mobile: {
      valueString: '480px',
      valueNumber: 480,
    },
  },
}

const GlobalStyle = createGlobalStyle`
  body {
    // hack for PDF preview with apryse
    iframe[title="js"] {
      position: absolute !important;
    }
  }

  * {
    font-family: ${({ theme }) => theme.fontFamily};

    user-select: none;
    &::-webkit-scrollbar {
      width: 8px;
      background-color: transparent;
    }

    &::-webkit-scrollbar-track {
      background-color: transparent;
      border-radius: 4px;
      margin: 8px 0;
    }

    &::-webkit-scrollbar-thumb {
      background-color: #E5E7EB;
      border-radius: 4px;
      transition: background-color 0.2s ease;

      &:hover {
        background-color: #D1D5DB;
      }
    }

    /* Firefox Scrollbar Styles */
    scrollbar-width: thin;
    scrollbar-color: #E5E7EB transparent;

    &:hover {
      scrollbar-color: #D1D5DB transparent;
    }
  }
  

  .crisp-client .cc-1brb6 .cc-1yy0g .cc-1no03 .cc-lso1a {
    padding-top: var(--safe-area-inset-top, 0px) !important;
  }

  .crisp-client .cc-1brb6 .cc-1yy0g .cc-1no03 .cc-rfbfu .cc-1iwcs .cc-1o220 {
    margin-bottom: calc(var(--safe-area-inset-top, 0px) + var(--safe-area-inset-bottom, 0px)) !important;
  }

  .crisp-client .cc-1brb6 .cc-1yy0g .cc-1no03 .cc-rfbfu .cc-1iwcs .cc-1nvun {
    margin-bottom: calc(var(--safe-area-inset-top, 0px) + var(--safe-area-inset-bottom, 0px)) !important;
  }

  .crisp-client {    
    a {
      &.cc-1m2mf {
        @media (max-width: ${({ theme }) => theme.responsive.tablet.valueString}) {
          margin-bottom: calc(55px + var(--safe-area-inset-bottom, 0px)) !important;
        }
      }
    }
  }
`

export { StyledTheme, GlobalStyle }
